<template>
  <div class="failureAccess">
    <i class="iconfont icon-tishi-icon icon"></i>
    <p class="title">无法评估</p>
    <div class="sepLineShell">
      <p class="sepLine"></p>
    </div>
    <div class="orderInfo">
      <div class="shell">
        <p class="list">
          <span class="fl">评估结果</span><span class="fr "><span
              class="seeDetail"
              @click="seeReason"
            >查看详情<i :class="{
                  'iconfont icon-shang': this.seeResult === false,
                  'iconfont icon-xia': this.seeResult === true,
                }"></i></span></span>
        </p>
      </div>
      <div
        class="reason"
        v-if="this.seeResult === true"
      >
        <p
          v-for="(item,
          index) in this.$store.state.commonForms.modalErrorReason.split('@')"
          :key="index"
        >
          {{ index - 0 + 1 }}. {{ item }}
        </p>
      </div>
      <div class="shell">
        <p class="list">
          <span class="fl">企业名称</span><span class="fr ">{{ this.$store.state.commonForms.corpName }}</span>
        </p>
        <p class="list">
          <span class="fl">借款人</span><span class="fr ">{{
            this.$store.state.commonForms.borrowerName
          }}</span>
        </p>
        <p class="list">
          <span class="fl">申请产品</span><span class="fr ">{{ this.$store.state.commonForms.productName, }}</span>
        </p>
        <p class="list">
          <span class="fl">申请时间</span><span class="fr ">{{ this.$store.state.commonForms.orderTime }}</span>
        </p>
      </div>
    </div>
    <div
      v-if="flag === 1"
      class="buttonGroup"
    >
      <van-button
        :type="type"
        class="reEvaluate button"
        @click="gotoReEvaluate"
        :disabled="countDownDisable"
        color="color"
      >
        <van-count-down
          :time="time"
          ref="countDown"
          @finish="finished"
        >
          <template v-slot="timeData">
            <span
              class="item cx"
              style="margin-right: 4px"
            >重新评估</span>
            <span
              class="item second cx"
              v-if="countDownDisable === true && timeData.seconds !== 0"
            >{{ timeData.seconds }}s</span>
          </template>
        </van-count-down>
      </van-button>

      <div
        class="seeDetails"
        @click="onDetails"
      >查看数据情况</div>
    </div>

    <van-button
      :type="type"
      class="reEvaluate button again"
      @click="gotoReEvaluate"
      :disabled="countDownDisable"
      color="color"
      v-if="flag === 2"
    >
      <van-count-down
        :time="time"
        ref="countDown"
        @finish="finished"
      >
        <template v-slot="timeData">
          <span style="margin-right: 4px; color: #fff">重新评估</span>
          <span
            class="item second"
            v-if="countDownDisable === true && timeData.seconds !== 0"
          >{{ timeData.seconds }}s</span>
        </template>
      </van-count-down>
    </van-button>
    <p class="teleInfo">如有疑问，请致电：400-851-2366转9</p>
  </div>
</template>

<script>
import { checkStatus } from './mixin';

export default {
  name: 'UnableAccess',
  data() {
    return {
      isLoading: false,
      time: 6000,
      countDownDisable: true,
      type: 'danger',
      color: '#B2B2B2',
      seeResult: false,
      flag: 0,
    };
  },
  mixins: [checkStatus],
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#fff');
    this.$store.dispatch('commonForms/checkCurrentStatus', true);
  },

  mounted() {
    this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: true });
    this.queryButtonIsShow();
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  methods: {
    onDetails() {
      const { orderId, productId } = this.$route.query;
      this.$router.push({
        path: '/supermarket/v2/dataAcquisition',
        query: {
          statusCode: 1,
          redirect: encodeURIComponent(`/supermarket/v2/UnableAccess?orderId=${orderId}&productId=${productId}`),
          orderId,
          productId,
        },
      });
    },
    async queryButtonIsShow() {
      const res = await this.$api.PublicPage.isDataAcquisition({
        orderId: this.$route.query.orderId,
        productId: this.$route.query.productId,
      });
      console.log(res, '==res');
      if (res.returnCode === '200' && res.data.type) {
        this.flag = 1;
      } else {
        this.flag = 2;
      }
    },
    finished() {
      this.countDownDisable = false;
      this.type = 'danger';
      this.color = '#F5514A';
      if (!this.$store.state.commonForms.canRetry) {
        this.countDownDisable = true;
      }
    },
    seeReason() {
      this.seeResult = !this.seeResult;
    },
    gotoReEvaluate() {
      this.$store.dispatch('commonForms/getModelV2');
    },
  },
};
</script>
<style scoped>
.buttonGroup {
  display: flex;
  margin-top: 80px;
  padding: 0 16px;
}
.seeDetails {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  font-weight: 600;
  background: #ff6538;
  border-radius: 4px;
  flex: 1;
  height: 44px;
  margin-left: 8px;
}
.failureAccess {
  padding-top: 90px;
}
.icon {
  color: #f5514a;
  font-size: 50px;
}
.reason {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 15px;
  color: #7c7c7c;
  font-size: 12px;
  text-align: left;
  background: #f8f9fb;
}
.none {
  display: none;
}
.seeDetail {
  color: #f55646;
}
.title {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}

.sepLineShell {
  box-sizing: border-box;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.sepLine {
  width: 100%;
  height: 1px;
  background: #dfdede;
}

.retry {
  float: left;
  width: 158px;
  margin-right: 8px;
  padding-right: 0;
  padding-left: 0;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
  line-height: 22px;
}
.fr {
  float: right;
  width: 70%;
  line-height: 22px;
  text-align: right;
}
.reEvaluate {
  width: 345px;
  font-size: 14px;
  flex: 1;
  background: #ffffff;
  border: 1px solid #bcc2cc;
  border-radius: 4px;
  color: #2f3133;
  margin-right: 8px;
}
.again {
  margin-right: 0;
  background: #ff6538;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
  border: none;
}
.teleInfo {
  color: #a2abb7;
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
}
.item {
  color: #fff;
}
.cx {
  color: #2f3133;
  font-size: 16px;
}
</style>
